export default __webpack_public_path__ + "static/media/dna-animation.b3814b21.svg";